// src/pages/UploadPage.jsx
import React, { useState } from "react";
import { presignUploads, putToSignedUrl } from "../api/uploads";
import { createJobCompat } from "../api/jobs";

export default function UploadPage() {
    const [file, setFile] = useState(null);
    const [progress, setProgress] = useState(0);
    const [msg, setMsg] = useState("");
    const [err, setErr] = useState("");

    const onStart = async () => {
        setErr("");
        setMsg("");
        setProgress(0);

        if (!file) {
            setErr("파일을 선택하세요");
            return;
        }

        try {
            setMsg("presign...");

            const pres = await presignUploads([file]);
            const bucket = pres?.bucket;
            const item0 = pres?.items?.[0];
            const objectKey = item0?.objectKey;
            const putUrl = item0?.putUrl;

            if (!bucket || !objectKey || !putUrl) {
                throw new Error("presign response invalid (bucket/items[0].objectKey/items[0].putUrl missing)");
            }

            setMsg("uploading to MinIO...");
            await putToSignedUrl(putUrl, file, setProgress);

            setMsg("create job...");

            const created = await createJobCompat(bucket, [objectKey], {
                inputType: "VIDEO",
                optionsJson: JSON.stringify({
                    originalName: file.name,
                    size: file.size,
                    contentType: file.type,
                }),
            });

            // 서버 응답 방어: id/jobId 둘다 대응
            const jobId = created?.jobId || created?.id || created?.data?.jobId || created?.data?.id;
            if (!jobId) {
                // 서버가 ok:false인데 apiJson에서 안 던진 경우 방어
                if (created && created.ok === false) {
                    throw new Error(created.message || "create job failed");
                }
                throw new Error("JOB create response missing id/jobId");
            }

            setMsg(`JOB created: ${jobId}`);
        } catch (e) {
            const msg =
                e?.message ||
                (typeof e === "string" ? e : "unknown error");
            setErr(msg);
        }
    };

    return (
        <div style={{ maxWidth: 980, margin: "40px auto", padding: "0 16px" }}>
            <h1 style={{ fontSize: 36, marginBottom: 8 }}>Upload</h1>
            <div style={{ color: "#666", marginBottom: 16 }}>
                파일 선택 → presign → PUT(MinIO) → POST /api/jobs → Worker 실행
            </div>

            <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 12 }}>
                <input type="file" onChange={(e) => setFile(e.target.files?.[0] || null)} />
                <button onClick={onStart}>Upload &amp; Start Job</button>
            </div>

            {file && (
                <div style={{ padding: 12, border: "1px solid #eee", borderRadius: 8, marginBottom: 12 }}>
                    <div><b>Name</b>: {file.name}</div>
                    <div><b>Size</b>: {(file.size / (1024 * 1024)).toFixed(2)} MB</div>
                    <div><b>Type</b>: {file.type || "unknown"}</div>
                </div>
            )}

            <div style={{ height: 10, background: "#eee", borderRadius: 999, overflow: "hidden", marginBottom: 12 }}>
                <div style={{ width: `${progress}%`, height: "100%", background: "#111827" }} />
            </div>

            {msg && (
                <div style={{ padding: 12, background: "#eef2ff", borderRadius: 8, marginBottom: 12 }}>
                    {msg}
                </div>
            )}

            {err && (
                <div style={{ padding: 12, background: "#fee2e2", borderRadius: 8 }}>
                    오류: {err}
                </div>
            )}
        </div>
    );
}
